import 'reflect-metadata';
import 'fix-date';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';

import {
  browserProfilingIntegration,
  browserTracingIntegration,
  captureException,
  init,
  replayIntegration,
} from '@sentry/angular';
import versions from './_versions';
import { AppBrowserModule } from './app/app.browser.module';
import { init_i18n } from './app/i18n/i18n';

/*
 */
init({
  dsn: environment.sentry_dsn,
  environment: environment.env,
  release: versions.versionLong,
  integrations: [
    browserTracingIntegration({}),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    browserProfilingIntegration(),
  ],

  tracesSampleRate: environment.sentrySampleRate ?? 0.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

console.debug('Sentry initialized. Env: ', environment);

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  void (async () => {
    await init_i18n();
    platformBrowserDynamic()
      .bootstrapModule(AppBrowserModule)
      .catch((err) => captureException(err));
  })();
});
